import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/apiService';
import { useLanguage } from '../contexts/LanguageContext';

function ForgotPassword() {
    const { t } = useLanguage();
    const [email, setEmail] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!email) {
            setErrorMessage(t('auth.forgotPassword.enterEmail'));
            return;
        }

        setLoading(true);
        setErrorMessage('');
        setSuccessMessage('');

        try {
            const response = await api.post('/auth/forgot-password', { email });
            setSuccessMessage(response.data.message || t('auth.forgotPassword.emailSent'));
            setEmail(''); // Clear the form
        } catch (error) {
            // Don't expose whether the email exists for security reasons
            setSuccessMessage(t('auth.forgotPassword.emailSentSecure'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container mt-5">
            <div className="text-center mb-4">
                <img 
                    src="/MUSI.ico" 
                    alt="MUSI Logo" 
                    className="img-fluid" 
                    style={{ maxHeight: '120px' }} 
                />
                <h2 className="mt-3">{t('auth.forgotPassword.title')}</h2>
            </div>

            <div className="row justify-content-center">
                <div className="col-md-6">
                    {errorMessage && (
                        <div className="alert alert-danger mb-3" role="alert">
                            {errorMessage}
                        </div>
                    )}

                    {successMessage && (
                        <div className="alert alert-success mb-3" role="alert">
                            {successMessage}
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="p-4 border rounded shadow-sm bg-white">
                        <p className="mb-3">
                            {t('auth.forgotPassword.instruction')}
                        </p>

                        <div className="mb-3">
                            <label htmlFor="email" className="form-label">{t('auth.forgotPassword.email')}</label>
                            <input
                                type="email"
                                id="email"
                                className="form-control"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder={t('auth.forgotPassword.emailPlaceholder')}
                                required
                            />
                        </div>

                        <button
                            type="submit"
                            className="btn btn-primary w-100"
                            disabled={loading}
                        >
                            {loading ? t('auth.forgotPassword.sending') : t('auth.forgotPassword.resetButton')}
                        </button>

                        <div className="mt-3 text-center">
                            <p>
                                {t('auth.forgotPassword.rememberPassword')} <Link to="/login">{t('auth.forgotPassword.loginLink')}</Link>
                            </p>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default ForgotPassword;